/* Maison Ella — GIFT OPTIONS: sacola pelo ícone de quick add e a mensagem
 * desenhada no cartão que vai dentro da caixa. */
(function () {
  'use strict';

  var SAMPLE = 'A little something just for you.';

  function onCartPage() {
    return document.body.classList.contains('template-cart');
  }

  function refreshCart() {
    // na página do carrinho a lista de itens é servida pelo Liquid:
    // recarregar é o que faz a sacola aparecer entre os produtos
    if (onCartPage()) { window.location.reload(); return Promise.resolve(); }
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart, cartCount: cart.item_count } }));
        document.dispatchEvent(new CustomEvent('theme:cart:update', { detail: { cart: cart, cartCount: cart.item_count } }));
        // é o theme:cart:refresh que faz a gaveta redesenhar a lista de itens
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        return cart;
      })
      .catch(function () {});
  }

  /* ── Sacola ── */
  function initBag(root) {
    if (root.dataset.giftReady) return;
    root.dataset.giftReady = '1';

    var err = root.querySelector('[data-gift-error]');
    var add = root.querySelector('[data-gift-add]');
    if (!add) return;
    var card = add.closest('.pdpb-gift__card-item');

    function fail(msg) {
      if (!err) return;
      err.textContent = msg || 'Something went wrong. Please try again.';
      err.hidden = false;
    }

    add.addEventListener('click', function () {
      if (err) err.hidden = true;
      add.disabled = true;

      if (card && card.classList.contains('is-added')) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: add.dataset.lineKey || add.dataset.variant, quantity: 0 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            card.classList.remove('is-added');
            add.disabled = false;
            refreshCart();
          })
          .catch(function () { add.disabled = false; fail(); });
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.variant), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          add.disabled = false;
          if (!res.ok) { fail(res.data && res.data.description); return; }
          if (card) card.classList.add('is-added');
          add.classList.add('just-added');
          window.setTimeout(function () { add.classList.remove('just-added'); }, 2400);
          refreshCart();
        })
        .catch(function () { add.disabled = false; fail(); });
    });
  }

  /* ── Mensagem ── */
  function initNote(note) {
    if (note.dataset.noteReady) return;
    note.dataset.noteReady = '1';

    var field = note.querySelector('[data-note-field]');
    var count = note.querySelector('[data-note-count]');
    var preview = note.querySelector('[data-note-preview]');
    var echo = note.querySelector('[data-note-echo]');
    if (!field || !echo || !preview) return;

    function paint() {
      var text = field.value.trim();
      echo.textContent = text || SAMPLE;
      preview.classList.toggle('is-empty', text.length === 0);
      if (count) count.textContent = field.value.length;
    }

    function save() {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Gift note': field.value.trim() } })
      }).catch(function () {});
    }

    field.addEventListener('input', paint);
    field.addEventListener('blur', save);
    paint();
  }

  /* Se a sacola for tirada pela lixeira da lista, o cartão volta ao normal. */
  function syncBag() {
    var add = document.querySelector('[data-gift-add]');
    if (!add) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var variant = Number(add.dataset.variant);
        var line = null;
        cart.items.forEach(function (i) { if (i.variant_id === variant) line = i; });
        document.querySelectorAll('[data-gift-add]').forEach(function (btn) {
          var card = btn.closest('.pdpb-gift__card-item');
          if (!card) return;
          card.classList.toggle('is-added', !!line);
          if (line) btn.dataset.lineKey = line.key;
        });
      })
      .catch(function () {});
  }

  function boot() {
    document.querySelectorAll('[data-pdpb-gift]').forEach(initBag);
    document.querySelectorAll('[data-gift-note]').forEach(initNote);
    syncBag();
  }

  boot();
  // a gaveta do carrinho é redesenhada a cada alteração
  document.addEventListener('theme:cart:change', boot);
  document.addEventListener('theme:cart:update', boot);
  document.addEventListener('theme:cart:refresh', boot);
  document.addEventListener('shopify:section:load', boot);
})();
